'use strict';

var Params = function Params(chartModel, sizingParams) {
  var TOP_PADDING = 10;
  var BOTTOM_PADDING = 50;
  var OUTER_PADDING = 45;
  var INNER_PADDING_LEFT = 45;
  var INNER_PADDING_RIGHT = 45;
  var LABEL_PADDING_LEFT = 30;
  var LABEL_PADDING_RIGHT = 30;
  var BASE_PADDING_LEFT = INNER_PADDING_LEFT + OUTER_PADDING;
  var EXTENDED_PADDING_LEFT = BASE_PADDING_LEFT + LABEL_PADDING_LEFT;
  var BASE_PADDING_RIGHT = INNER_PADDING_RIGHT + OUTER_PADDING;
  var EXTENDED_PADDING_RIGHT = BASE_PADDING_RIGHT + LABEL_PADDING_RIGHT;
  var BASE_PADDING = BASE_PADDING_LEFT + BASE_PADDING_RIGHT;
  function calculateBarWidth(chartCount, totalWidth, totalClassCount) {
    var totalReservedSpace = chartCount * BASE_PADDING + LABEL_PADDING_LEFT + LABEL_PADDING_RIGHT;
    return Math.floor((totalWidth - totalReservedSpace) / totalClassCount);
  }
  return function (containerWidth, containerHeight) {
    var padding = {
      top: TOP_PADDING,
      bottom: BOTTOM_PADDING,
      left: BASE_PADDING_LEFT,
      right: BASE_PADDING_RIGHT
    };
    if (chartModel.isFirst) {
      padding.left = EXTENDED_PADDING_LEFT;
    }
    if (chartModel.isLast) {
      padding.right = EXTENDED_PADDING_RIGHT;
    }
    var barWidth = calculateBarWidth(sizingParams.chartCount, sizingParams.containerWidth, sizingParams.totalClassCount);
    var width = chartModel && chartModel.data ? barWidth * chartModel.data.length : 100;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: width + padding.left + padding.right,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      yAxisShift: 14,
      yAxisLabelShift: 68,
      yAxisRightShift: 14,
      yAxisRightLabelShift: 68,
      forceWidth: true,
      indexToColor: function indexToColor(i) {
        switch (i) {
          case 11:
            //January
            return '#ff8d2e';
          case 10:
            //February
            return '#ffc694';
          case 9:
            return '#206080';
          case 8:
            return '#3399cc';
          case 7:
            return '#a2d8f2';
          case 6:
            return '#53335e';
          case 5:
            return '#b27ec4';
          case 4:
            return '#e4cfec';
          case 3:
            return '#195e51';
          case 2:
            return '#28927d';
          case 1:
            return '#abded4';
          case 0:
            //December
            return '#ff3300';
        }
      }
    };
  };
};
module.exports = Params;